<script lang="ts">
    import { reviewsGalleryModalToken } from "@apps/reviews/tokens";
    import { createEventDispatcher } from "svelte";

    import ManagedModalWithDialog from "@components/Modal/ManagedModalWithDialog.svelte";
    import { ModalManager } from "@components/Modal/ModalManager";
    import ModalManagerProvider from "@components/Modal/ModalManager/ModalManagerProvider.svelte";

    import ReviewsGalleryCloseButton from "./ReviewsGalleryCloseButton.svelte";

    export let modalManager: ModalManager;

    const dispatch = createEventDispatcher();

    const handleClose = () => {
        dispatch("closeModal");
    };
</script>

<ModalManagerProvider {modalManager}>
    <ManagedModalWithDialog
        modalToken={reviewsGalleryModalToken}
        on:close={handleClose}
        modalClass="gw-rv-gallery-modal"
        dialogClass="gw-rv-gallery-modal-dialog"
        modalBodyClass="gw-rv-gallery-modal-body"
        closeIcon={ReviewsGalleryCloseButton}
        disablePortal
    >
        <slot />
    </ManagedModalWithDialog>
</ModalManagerProvider>

<style lang="postcss">
    :global(div.gw-modal.gw-rv-gallery-modal) {
        z-index: calc(var(--gw-z-index-modal) - 1);
    }

    :global(.gw-rv-gallery-modal .gw-modal-dialog.gw-rv-gallery-modal-dialog) {
        padding: 0;

        @media screen and (max-width: 600px) {
            max-width: 100%;
            width: 100%;
            align-self: stretch;
            margin: 0;
        }
    }

    :global(.gw-rv-gallery-modal .gw-modal-body.gw-rv-gallery-modal-body) {
        padding: 0;
        max-width: 1000px;
        width: 100%;
        min-height: 692px;
        height: 1px;
        box-sizing: content-box;
        overflow: hidden;
        border-radius: 2px;

        @media screen and (max-width: 1200px) {
            width: 80vw;
        }

        @media screen and (max-width: 1000px) {
            height: 80vh;
        }

        @media screen and (max-width: 800px) {
            width: 70vw;
            min-height: 80vh;
            flex-direction: column;
        }

        @media screen and (max-width: 600px) {
            width: 100%;
            min-height: 100%;
            height: auto;
        }

        /* @media screen and (max-width: 400px) {
            width: 90vw;
            min-height: 95vh;
        } */
    }

    @media screen and (max-width: 600px) {
        :global(
                .gw-rv-gallery-modal
                    .gw-modal-dialog.gw-rv-gallery-modal-dialog
                    .gw-modal-header__close_btn
            ) {
            padding: 0;
            border-radius: 0;
        }
    }
</style>
